import func from './func';
import fetch from './request';

let requrstBasePathPc = "/pc/v1";
let requrstBasePathApi = "/api/v1";

const Api = {
    /**
     * 获得量表详情
     * @param {int} id
     * @param {string} associate 推广信息
     */
    async getQuestion(id, associate) {
        let url = '/scale/question/' + id
        url += associate ? '/' + associate : ''
        let res = await fetch.request(requrstBasePathPc + url, '', 'GET', true)
        if (res.code === 200) {
            return res.data
        }
        return null
    },

    /**
     * 提交用户答案
     *
     * @param {*} content
     * @returns
     */
    async submitUserAnswer(content) {
        let res = await fetch.request(requrstBasePathPc + '/scale/answer', content, 'POST', false)
        if (res.code === 200) {
            return res.data
        }

        return null
    },

	async submitUserAllAnswer(content) {
        let res = await fetch.request(requrstBasePathPc + '/testing/submit', content, 'POST', false)
        if (res.code === 200) {
            return res
        }
        return null
	},

    /**
     * 统一下单
     * @param type 类型 1:测评 2:课程
     * @param tid 测试ID
     * @param browser 浏览器类型
     * @param userAgent 浏览器标识
     */
    async getPayData(type, tid, browser, userAgent) {
        let res = await fetch.request(requrstBasePathPc + '/scale/unify/' + type + '/' + tid + '/' + browser + '/' + userAgent, '', 'GET', true)
        if (res.code === 200) {
            return res.data
        }
        return null
    },
	
	/**
	 * 支付宝mobile支付
	 * @param type 类型 1:测评 2:课程
	 * @param tid 测试ID
	 * @param userAgent 浏览器标识
	 */
	async mobileAlipay(type, tid, url, userAgent) {
		let res = await fetch.request(requrstBasePathPc + '/scale/alipay/h5/unify',{
			type,
			tid,
			url,
			userAgent
		}, 'POST', true)
		if (res.code === 200) {
			return res.data
		}
		return null
	},

    /**
     * 读取测试报告
     *
     * @param {*} id
     * @returns
     */
    async getUserReport(id) {
        let res = await fetch.request(requrstBasePathPc + '/scale/report/' + id, '', 'GET', false)
        if (res.code === 200) {
            return res.data
        }
        return null
    },
	
	/**
	 * 匿名读取测试报告
	 *
	 * @param {*} content
	 * @returns
	 */
	async getUserAnonymityReport(id) {
		return await fetch.request(requrstBasePathApi + '/scale/report/anon/' + id, '', 'GET', false)
			.then((res) => {
				if (res.code === 200) {
					return res.data
				}
				return null
			})
	},

    /**
     * 获取pc端支付链接
     *
     * @param {*} id
     * @returns
     */
    async getPcQrcode(id, associate) {
        let uri = '/scale/pc/qrcode/' + id
        if (associate) {
            uri = uri + '/' + associate
        }
        let res = await fetch.request(requrstBasePathPc + uri, '', 'GET', false)
        if (res.code === 200) {
            return res.data
        }
        return null
    },

    /**
     * 获得测试信息
     * @param {int} id
     */
    async getTesting(id) {
        let res = await fetch.request(requrstBasePathPc + '/scale/testing/' + id, '', 'GET', false)
        if (res.code === 200) {
            return res.data
        }
        return null
    },

    /**
     * 获得测试状态信息
     * @param {int} id
     */
    async getTestingStatus(id) {
        let res = await fetch.request(requrstBasePathPc + '/scale/testing/status/' + id, '', 'GET', false)
        if (res.code === 200) {
            return res.data
        }
        return null
    },

	/**
	 * 获取首页数据
	 */
	async getIndexData(tagids) {
		return await fetch.request(requrstBasePathApi + '/home/testing/' + tagids, '', 'GET', false)
			.then((res) => {
				if (res.code === 200) {
					return res.data
				}
				return res.subCode
			})
	},
	
	/**
	 * 获取测评详情描述
	 */
	async getTestInfo(id) {
		return await fetch.request(requrstBasePathApi + '/scale/' + id, '', 'GET', false)
			.then((res) => {
				if (res.code === 200) {
					return res.data
				}
				return res.subCode
			})
	},
	
	/**
	 * 获取推广渠道统计信息
	 */
	async getBaiduTotalId(associate) {
		if(!associate){
			return null
		}
		return await fetch.request(requrstBasePathApi + '/associates/info/' + associate, '', 'GET', false)
			.then((res) => {
				if (res.code === 200) {
					return res.data
				}
				return null
			})
	},
	
	/**
	 * 复制广告码
	 */
	async getGlobalConfig(type) {
		return await fetch.request(requrstBasePathApi + '/cfg/' + type, '', 'GET', false)
			.then((res) => {
				if (res.code === 200) {
					return res.data
				}
				return null
			})
	},

	/**
	 * 渠道数据上报
	 *	associate
	 */
	async reportedData() {
		let url = window.location.href;

		let associate = func.getParameter(url, 'associate');
		if (associate == 'null') {
			return
		}
		//存储推广参数
		window.localStorage.setItem('currentAssociate', associate);
		let currentArr = window.localStorage.getItem('associate');
		if (!currentArr) {
			currentArr = [];
		} else {
			currentArr = JSON.parse(currentArr);
		}
		// console.log(currentArr)
		//获取当前时间
		let currentTime = new Date().getHours();

		for (let item of currentArr) {
			if (item.key == associate) {
				let prevTime = parseInt(item.time);
				currentTime = parseInt(currentTime);
				if (currentTime - prevTime >= 0) {
					return
				}
			}
		}

		return await fetch.request(requrstBasePathPc + '/scale/increase/' + associate, '', 'GET', false)
			.then((res) => {
				if (res.code === 200) {

					let isFlag = false;

					let postTime = new Date().getHours();
					//存在的话更新时间  不存在添加数据
					for (let item of currentArr) {
						if (item.key == associate) {
							isFlag = true;
							item.time = postTime;
							break
						}
					}

					if (!isFlag) {
						currentArr.push({
							key: associate,
							time: postTime
						});
					}
					currentArr = JSON.stringify(currentArr);
					window.localStorage.setItem('associate', currentArr);
				}
			})
	},

	/**
	 *  按赠送查看报告列表
	 */
	async reportlist(userid) {
		return await fetch.request(requrstBasePathPc + '/view/report/' + userid, '', 'GET', false)
			.then((res) => {
				if (res.code === 200) {
					return res.data
				}
				return null
			})
	}
}

export default Api
